import { render, staticRenderFns } from "./Concepts.vue?vue&type=template&id=24b56308&scoped=true"
import script from "./Concepts.vue?vue&type=script&lang=ts"
export * from "./Concepts.vue?vue&type=script&lang=ts"
import style0 from "./Concepts.vue?vue&type=style&index=0&id=24b56308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b56308",
  null
  
)

export default component.exports